import type { OrderTableSettingsData } from '@frontend/api';
import { useDisclosure } from '@frontend/components';

import { CustomizeView as BaseCustomizeView } from 'components/listTablePage';

import { OrderTableSettingsForm } from './orderTableSettingsForm';

export type CustomizeViewProps = {
  userId: string;
  orderTableSettings: OrderTableSettingsData;
};

export const CustomizeView = ({
  userId,
  orderTableSettings,
}: CustomizeViewProps) => {
  const disclosureProps = useDisclosure();
  const { onClose } = disclosureProps;

  return (
    <BaseCustomizeView {...disclosureProps}>
      <OrderTableSettingsForm
        userId={userId}
        settings={orderTableSettings}
        onCloseSettingsPopover={onClose}
      />
    </BaseCustomizeView>
  );
};
